import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventSpaces]',
})
export class PreventSpacesDirective {
  constructor() {}

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const value = input.value;
    input.value = value.trimStart(); // Remove extra whitespace from start of input
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Check if the key pressed is space and if the input field is empty
    if (event.key === ' ' && (event.target as HTMLInputElement).value.trim() === '') {
      event.preventDefault();
    }
  }
}
